import { Trans, withI18n } from '@lingui/react'
import classNames from 'classnames'
import { bool } from 'prop-types'

import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import { TENANT_IT } from 'shared/consts/tenants'
import IconChat from 'views/components/atoms/Icon/IconChat'
import IconHeart from 'views/components/atoms/Icon/IconHeart'
import IconHeartFilled from 'views/components/atoms/Icon/IconHeartFilled'
import IconShareAlt from 'views/components/atoms/Icon/IconShareAlt'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Tooltip from 'views/components/molecules/Tooltip'
import {
  ADVICE_MODAL_ID,
  LOGIN_MODAL_ID,
  SOCIAL_MODAL_ID,
} from 'views/consts/names'
import { i18nType } from 'views/utils/propTypes'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import './BuyBoxIconList.scss'

const BuyBoxIconList = ({
  showAddWishList,
  showSocials,
  showPersonalAdvice,
  i18n,
}) => {
  const { tenant } = usePublicConfig()
  const shouldSquashLastItem = tenant === TENANT_IT

  const baseListClasses =
    'a-list-reset l-flex@medium u-margin--bottom@small-tiny'
  const listClasses = classNames(baseListClasses, {
    'l-flex--distribute-space': showPersonalAdvice,
  })

  const baseItemClasses =
    'u-padding-x-small--ends@small-tiny o-BuyBoxIconList__item'
  const itemClasses = classNames(baseItemClasses, {
    'o-BuyBoxIconList__item--incomplete-width': !showPersonalAdvice,
  })
  const socialClassName = classNames(itemClasses, {
    'u-border--top@small-tiny': showAddWishList,
  })
  const adviceClassName = classNames(itemClasses, {
    'u-border--top@small-tiny': showAddWishList || showSocials,
    'o-BuyBoxIconList__item--advice': shouldSquashLastItem,
  })

  return (
    <ul className={listClasses}>
      <li
        data-prescription-type-switch="true"
        className={itemClasses}
        aria-hidden={showAddWishList ? null : 'true'}
        data-clientside-hook="o-BuyBoxWishList__listItem"
      >
        <div
          data-prescription-types={PRESCRIPTION_TYPE_NO_PRESCRIPTION}
          data-clientside-hook="o-BuyBoxWishList__wrapper"
        >
          <ButtonAsLink
            data-a11y-dialog-show={LOGIN_MODAL_ID}
            name="add-to-wishlist-tooltip"
            id="add-to-wishlist-tooltip"
            data-clientside-hook="add-to-wishlist-tooltip o-BuyBoxWishList__button wishListButton"
            isClientsideControlled
            ariaControls="add-to-wishlist-tooltip"
            ariaDescribedby="add-to-wishlist-tooltip"
          >
            <span
              className="o-BuyBoxWishList__tooltip-icon o-BuyBoxWishList__tooltip-icon-item"
              data-clientside-hook="o-BuyBoxWishList__heartFilled-icon"
            >
              <IconHeart />
            </span>
            <span
              className="o-BuyBoxWishList__tooltip-icon o-BuyBoxWishList__heartFilled o-BuyBoxWishList__tooltip-icon-item"
              data-clientside-hook="o-BuyBoxWishList__heart-icon"
              aria-hidden
            >
              <IconHeartFilled />
            </span>
            <span className="u-margin-x-small--left u-font-weight--bold o-BuyBoxWishList__tooltip-icon-item">
              <Trans id="general.button.label.memorise" />
            </span>
          </ButtonAsLink>
        </div>
        <Tooltip
          isVisible={false}
          text={i18n._('productDetailsPage.addToNotepad.tooltip.error')}
          noFullWidthMobile
          id="add-to-wishlist-tooltip-text"
          sideRendered="bottom"
        />
      </li>
      <li className={socialClassName} aria-hidden={showSocials ? null : 'true'}>
        <ButtonAsLink
          name="buybox-large_shareProduct"
          type="button"
          isClientsideControlled
          data-a11y-dialog-show={SOCIAL_MODAL_ID}
          title={i18n._('general.label.day.share')}
          data-clientside-hook="shareButton"
        >
          <IconShareAlt />
          <span className="u-margin-x-small--left u-font-weight--bold o-BuyBoxWishList__item-text">
            <Trans id="general.label.day.share" />
          </span>
        </ButtonAsLink>
      </li>
      {showPersonalAdvice && (
        <li
          data-clientside-hook="buyboxPersonalAdviceLink"
          className={adviceClassName}
        >
          <ButtonAsLink
            isClientsideControlled
            data-a11y-dialog-show={ADVICE_MODAL_ID}
            name="buybox-large_markProduct-show-advice-modal"
            title={i18n._('buyBox.link.label.personalAdvice')}
            data-clientside-hook="adviceButton"
          >
            <IconChat />
            <span
              className={classNames(
                'u-font-weight--bold u-margin-x-small--left o-BuyBoxWishList__item-text',
                {
                  'u-margin-small--left@medium': shouldSquashLastItem,
                }
              )}
            >
              <Trans id="buyBox.link.label.personalAdvice" />
            </span>
          </ButtonAsLink>
        </li>
      )}
    </ul>
  )
}

BuyBoxIconList.propTypes = {
  i18n: i18nType.isRequired,
  showAddWishList: bool,
  showSocials: bool,
  showPersonalAdvice: bool,
}

BuyBoxIconList.defaultProps = {
  showAddWishList: false,
  showSocials: false,
  showPersonalAdvice: false,
}

export default withI18n()(BuyBoxIconList)
